import * as NEA from 'fp-ts/NonEmptyArray';

export function fpTsNonEmptyArrayToZodNonEmptyArray<A>(array: NEA.NonEmptyArray<A>): [A, ...A[]] {
  return [NEA.head(array), ...NEA.tail(array)];
}